var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_vm._v(" @todo use CountDown Component ")])
}
var staticRenderFns = []

export { render, staticRenderFns }